import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import DateRange from "../../common/dateRange";
import * as R from "ramda";
import Api from "../../../../../Services/Api";
import {HttpStatus, Status} from "../../../../common/Constants";
import {mapToObjectDDL} from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import M from "moment/moment";

class TabKwitansiBatalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      bankOptions: [],
      documentOptions: [],
    }
  }

  async componentDidMount() {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const bankOptions = [];
    const documentOptions = [];
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank({
        paramFilters: {
          kodecabang: [this.props.kodeCabang],
          status: Status.ACTIVE,
        },
      }),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "DOCUMENT_TYPE",
          status: Status.ACTIVE,
        },
      })
    ]);

    responses.forEach((response, idx) => {
      if (idx === 0) {
        if (response.data.status === HttpStatus.SUCCESS) {
          bankOptions.push(
              ...response.data.data.map((d) => mapToObjectDDL(d.bankName, d.bankCode))
          );
        }
      } else if (idx === 1) {
        if (response.data.status === HttpStatus.SUCCESS) {
          documentOptions.push(...response.data.data.map((d) => mapToObjectDDL(d.value, d.key)));
        }
      }
    });

    this.setState((prevValue) => ({
      ...prevValue,
      bankOptions,
      documentOptions,
      loading: false,
    }));
  }

  getDataValue(fieldName) {
    return !R.isNil(this.props.data) && this.props.data[fieldName]
      ? this.props.data[fieldName]
      : null;
  }

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <SimpleDDL
              id="filter"
              box="search"
              name="paymentType"
              placeholder="ALL/BBM/BBK"
              isClearable
              options={[
                {value: null, label: "ALL"},
                {value: "IN", label: "BBM"},
                {value: "OUT", label: "BBK"},
              ]}
              value={this.getDataValue("paymentType")}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <DateRange
              label="Tanggal BBM/BBK"
              startDateName="startBbkBbmDate"
              endDateName="endBbkBbmDate"
              data={this.props.data}
              onStartDateChange={(name, value) =>
                  this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
              onEndDateChange={(name, value) =>
                  this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleInput
              id="input_text_nomor_bbm"
              name="paymentBankId"
              label="Nomor BBM/BBK"
              value={this.getDataValue("paymentBankId")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleDDL
              id="select_options_jenis_dokumen"
              name="keyDocumentType"
              label="Jenis Dokumen"
              box="search"
              value={this.getDataValue("keyDocumentType")}
              isClearable
              options={this.state.documentOptions}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <SimpleInput
              id="input_text_no_doc_ref1"
              name="documentRef1No"
              label="Nomor Dokument Ref 1"
              value={this.getDataValue("documentRef1No")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <DateRange
              label="Tanggal Dokumen Ref 1"
              startDateName="startDocumentRef1Date"
              endDateName="endDocumentRef1Date"
              data={this.props.data}
              onStartDateChange={(name, value) =>
                  this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
              onEndDateChange={(name, value) =>
                  this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleDDL
              id="select_options_kode_kas"
              name="bankId"
              label="Nama Bank"
              box="search"
              isClearable
              options={this.state.bankOptions}
              value={this.getDataValue("bankId")}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <SimpleInput
              id="input_text_terima_dari"
              name="transactionPersonName"
              label="Terima Dari/Bayar Kepada"
              value={this.getDataValue("transactionPersonName")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleTextArea
              id="input_text_guna_membayar"
              name="paymentPurpose"
              label="Guna Membayar"
              value={this.getDataValue("paymentPurpose")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleTextArea
              id="input_text_keterangan"
              name="note"
              label="Keterangan"
              value={this.getDataValue("note")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <div style={{ textAlign: "center" }}>
              <SimpleButton secondary onClick={this.props.onClear}>
                Hapus
              </SimpleButton>
              <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
            </div>
            {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
          </ModalContainer>
        }
      />
    );
  }
}

export default TabKwitansiBatalFilter;
